import React from "react";
import "./loader.css";

const Loader = (props) => {
  return (
    <div className="loader">
      <div className="bar"></div>
      <div className='loading'>{props.text === "Submitting Absence Request.." ? props.text : "Loading..."}</div>
    </div>
  );
};

export default Loader;
